import { Card, Col, Row, Spin } from 'antd'
import { useRolodexFileLS } from 'features/rolodex'
import { FC, useEffect, useMemo, useState } from 'react'

import { NiiSourcesParams, NiiViewProps } from './NiiDetailsModal'
import { NiiSourcesFileList } from './NiiSourcesFileList'
import { NiiSourcesRightPanel } from './NiiSourcesRightPanel'

export const NiiSourcesView: FC<NiiViewProps> = ({ niiId, niiData }) => {
  const [hoveredParam, setHoveredParam] = useState<
    keyof NiiSourcesParams | null
  >(null)
  const [hoveredFilePath, setHoveredFilePath] = useState<string | null>(null)

  useEffect(() => {
    if (hoveredParam && niiData.params) {
      setHoveredFilePath(niiData.params[hoveredParam]?.file_path ?? null)
    } else {
      setHoveredFilePath(null)
    }
  }, [hoveredParam, niiData.params])

  const { fileRefs: _fileRefs, isLoading: filesLoading } = useRolodexFileLS(
    useMemo(
      () => ({
        entry_id: niiId,
        path: '/nii_source/*',
      }),
      [niiId]
    )
  )
  const fileRefs = useMemo(
    () => _fileRefs.filter((f) => f.path.toLowerCase().endsWith('.pdf')),
    [_fileRefs]
  )
  const isLoading = filesLoading

  const unsourcedParams: ReadonlyArray<keyof NiiSourcesParams> = useMemo(
    () =>
      Object.entries(niiData.params ?? {})
        .filter(
          ([, val]) =>
            !val.file_path || !fileRefs.some((fr) => fr.path === val.file_path)
        )
        .map(([param]) => param as keyof NiiSourcesParams),
    [fileRefs, niiData.params]
  )

  return (
    <Row gutter={16}>
      {/* Left Column: File List */}
      <Col span={8}>
        <Card title='Files'>
          <Spin spinning={isLoading}>
            <NiiSourcesFileList
              fileRefs={fileRefs}
              hoveredFilePath={hoveredFilePath}
            />
          </Spin>
        </Card>
      </Col>

      {/* Right Column: Open Space for Other Content */}
      <Col span={16}>
        <Card title='Details'>
          <NiiSourcesRightPanel
            entryId={niiId}
            niiData={niiData}
            setHoveredParam={setHoveredParam}
            unsourcedParams={unsourcedParams}
          />
        </Card>
      </Col>
    </Row>
  )
}
